var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V54C60 58.4183 56.4183 62 52 62H8C3.58172 62 0 58.4183 0 54V8Z",
    fill: "#FFF1DF",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8464 33.293C25.8464 32.8874 25.6853 32.4984 25.3985 32.2116C25.1117 31.9248 24.7227 31.7636 24.3171 31.7636H19.8223C19.4759 31.8312 19.1168 31.7769 18.8059 31.61C18.495 31.4431 18.2514 31.1738 18.1164 30.8477C17.9814 30.5217 17.9632 30.159 18.0651 29.8211C18.1669 29.4833 18.3825 29.191 18.6752 28.9939L29.13 18.5407C29.3014 18.3693 29.5049 18.2333 29.7289 18.1405C29.9529 18.0477 30.1929 18 30.4353 18C30.6777 18 30.9178 18.0477 31.1418 18.1405C31.3657 18.2333 31.5692 18.3693 31.7406 18.5407L42.1939 28.9939C42.4866 29.191 42.7022 29.4833 42.804 29.8211C42.9059 30.159 42.8878 30.5217 42.7527 30.8477C42.6177 31.1738 42.3741 31.4431 42.0632 31.61C41.7523 31.7769 41.3932 31.8312 41.0469 31.7636H36.552C36.1464 31.7636 35.7574 31.9248 35.4706 32.2116C35.1838 32.4984 35.0227 32.8874 35.0227 33.293V36.3517C35.0227 36.7574 34.8615 37.1464 34.5747 37.4332C34.2879 37.72 33.8989 37.8811 33.4933 37.8811H27.3758C26.9702 37.8811 26.5812 37.72 26.2944 37.4332C26.0076 37.1464 25.8464 36.7574 25.8464 36.3517V33.293Z",
    stroke: "#D47F1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8438 44H35.02",
    stroke: "#D47F1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveJobsIcon);
export default __webpack_public_path__ + "static/media/active-jobs-icon.79c9b267c3a059f46a67d47a3dcc32c2.svg";
export { ForwardRef as ReactComponent };